import { createContext, useEffect, useState } from "react";
import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import { empty, isObject } from "../../Utilities/utils";
import { ProgressSpinner } from "primereact/progressspinner";
import { getAdminDetails } from "../../api/GetAdminDetails";

// css

export const AuthContext = createContext();

export const ProtectedRoute = () => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const getUser = async () => {
      const adminDetails = await getAdminDetails();
      if (
        !empty(adminDetails) &&
        adminDetails.success &&
        !empty(adminDetails.response)
      ) {
        const data = isObject(adminDetails?.response)
          ? adminDetails.response
          : {};

        setUser(data);
        setIsLoggedIn(true);
      } else {
        setUser({});
        setIsLoggedIn(false);
        navigate("/");
      }
    };
    getUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (user === null) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(255,255,255,0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ProgressSpinner
          style={{ width: 50, height: 50 }}
          strokeWidth={9}
          animationDuration={0.5}
        />
      </div>
    );
  }

  return user && !empty(user.userType) && user.userType === "SUPERADMIN" ? (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        isLoggedIn,
        setIsLoggedIn,
      }}
    >
      <Outlet />
    </AuthContext.Provider>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoute;
